import { message } from "antd";
import moment from "moment";
import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector, useDispatch, useStore } from 'react-redux';
import fuuid from 'react-uuid'
import numeral from 'numeral';
import PubSub from 'pubsub-js'
var _ = require('lodash');
//--------------------------------------------------------------
export const publish = (msg, data) => {
    PubSub.publish(msg, data);
};
export const subscribe = (msg, func) => {
    return PubSub.subscribe(msg, func);
};
export const unsubscribe = (token) => {
    PubSub.unsubscribe(token);
};
//--------------------------------------------------------------
export const HasRole = (user, name) => {
    if (user && user.roleUser) {
        if (_.isArray(name)) {
            for (let i = 0; i < user.roleUser.length; i++) {
                const element = user.roleUser[i];
                if (_.includes(name, element.role.name)) {
                    return true;
                }
            }
        } else {
            for (let i = 0; i < user.roleUser.length; i++) {
                const element = user.roleUser[i];
                if (element.role.name === name) {
                    return true;
                }
            }
        }
    }
    return false;
};
//--------------------------------------------------------------
export const unwrap = (value, element) => {
    if (_.isFunction(value) == true) {
        return unwrap(value());
    } else if (_.isArray(value)) {
        return value
    }
    return (!element) ? [value] : value;
};
//--------------------------------------------------------------
// Если все переданные аргументы не false/undefined/null/0
export const If = (equations, truthful) => {
    return (And(equations)) ? unwrap(truthful, true) : undefined;
};
export const IfElse = (equations, truthful, untruthful) => {
    return (And(equations)) ? unwrap(truthful, true) : unwrap(untruthful, true);
};
// Логическое И всех переданных аргументов
export const And = (args) => {
    var acc = true;
    let unwraped = unwrap(args);
    for (let i = 0; i < unwraped.length; i++) {
        const element = unwraped[i];
        acc = acc && element;
        if (!acc) break;
    }
    return acc;
};
// Логическое ИЛИ всех переданных аргументов
export const Or = (args) => {
    var acc = true;
    let unwraped = unwrap(args);
    for (let i = 0; i < unwraped.length; i++) {
        const element = unwraped[i];
        acc = acc || element;
    }
    return acc;
};
//--------------------------------------------------------------
const Created = () => { }; // Разрешение на создание
const Readed = () => { }; // Разрешение на чтение
const Updated = () => { }; // Разрешение на обновление
const Deleted = () => { }; // Разрешение на удаление
const Executed = () => { }; // Разрешение на исполнение
//--------------------------------------------------------------
export const uncapitalize = (str) => {
    return str.charAt(0).toLowerCase() + str.slice(1);
}
//--------------------------------------------------------------
export const QueryParams = (queryParams) => {
    let ext = "";
    if (queryParams) {
        for (let i = 0; i < queryParams.length; i++) {
            const param = queryParams[i];
            if (_.isString(param)) {
                ext += (!ext) ? param : '&' + param;
            } else if (_.isFunction(param)) {
                ext += (!ext) ? param() : '&' + param();
            }
        }
    }
    return ext;
};
export const QueryFunc = (func, name) => {
    return `f-${func}-${name}`;
};
export const QueryParam = (name, value) => {
    return `${name}=${value}`;
};
export const QueryOrder = (name, value) => {
    return `s-${name}=${value}`;
};
export const QueryDetail = (value) => {
    return QueryParam("detail", (value) ? value : "none");
};
//--------------------------------------------------------------
export const CREATE = (auth, name, object, callback, error) => {
    POST(auth, '/api/query-create/' + name.toLowerCase(), object, callback, error);
};
export const READ = (auth, name, callback, error) => {
    GET(auth, '/api/query/' + name.toLowerCase(), callback, error);
};
export const READWITH = (auth, name, queryParams, callback, error) => {
    let ext = QueryParams(queryParams);
    GET(auth, '/api/query/' + name.toLowerCase() + ((ext) ? "?" + ext : ""), callback, error);
};
export const UPDATE = (auth, name, object, callback, error) => {
    POST(auth, '/api/query-update/' + name.toLowerCase(), object, callback, error);
};
export const DELETE = (auth, name, id, callback, error) => {
    GET(auth, '/api/query-delete/' + name.toLowerCase() + '/' + id, callback, error);
};
export const POST = (auth, url, object, callback, error) => {
    auth.fetch(url, {
        method: 'POST',
        body: JSON.stringify(object)
    }).then(res => {
        if (res && res.status === true) {
            if (callback) {
                callback(res);
            }
        } else if (res && res.status === false) {
            if (error) {
                error(res, "fail");
            }
        }
    }).catch(function (err) {
        if (error) {
            error(err, "error");
        }
    });
};
export const POSTFormData = (auth, url, formData, callback, error) => {
    auth.fetchForData(url, {
        method: 'POST',
        body: formData
    }).then(res => {
        if (res && res.status === true) {
            if (callback) {
                callback(res);
            }
        } else if (res && res.status === false) {
            if (error) {
                error(res, "fail");
            }
        }
    }).catch(function (err) {
        if (error) {
            error(err, "error");
        }
    });
};
export const GETWITH = (auth, url, queryParams, callback, error) => {
    let ext = QueryParams(queryParams);
    GET(auth, url + ((ext) ? "?" + ext : ""), callback, error);
};
export const GET = (auth, url, callback, error) => {
    auth.fetch(url).then(res => {
        if (res && res.status === true) {
            if (callback) {
                callback(res);
            }
        } else if (res && res.status === false) {
            if (error) {
                error(res, "fail");
            }
        }
    }).catch(function (err) {
        if (error) {
            error(err, "error");
        }
    });
};
//--------------------------------------------------------------
export const equals = (obj1, obj2) => {
    if (obj1 === obj2)
        return true;
    if (!obj1 || !obj2 || typeof (obj1) !== "object" || typeof (obj2) !== "object")
        return false;
    //Проверяем является ли объект obj1 функцией, 
    //если да то предполагаем что obj2 тоже функция и сранвиваем коды функций 
    if (typeof (obj1) === "function") {
        if (obj1.toString() === obj2.toString())
            return true;
        else
            return false;
    }

    //Если obj2 является функцией, значит предыдущее условие 
    //показало что obj1 не является функцией, а значит obj1 != obj2
    if (typeof (obj2) === "function") {
        return false;
    }

    var obj1PropertyCount = Object.keys(obj1).length;
    var obj2PropertyCount = Object.keys(obj2).length;
    //Если количество свойств сравниваемых объектов разное, то объекты не равны
    if (obj1PropertyCount !== obj2PropertyCount)
        return false;
    //Так как предыдущее условие показало, что кол-во свойст у объектов равны, 
    //проверяем если кол-во свойств объектов равно 0, то объекты пустые, 
    //а соответственно равны
    if (obj1PropertyCount === 0)
        return true;
    for (var property in obj1) {
        var prop1 = obj1[property];
        var prop2 = obj2[property];
        //Если свойсвто prop1 является объектом, то предполагаем, 
        //что prop2 тоже объекта и проверяем на равенстов объектов свойства prop1 и prop2 
        if (typeof (prop1) === "object") {
            if (!equals(prop1, prop2)) {
                return false;
            }
            //Иначе если prop1 не является обхектом, а prop2 является объектом, 
            //останавливем сравнение
        } else if (typeof (prop2) === "object") {
            return false;
            //Если prop1 и prop2 не яляются объектами, то просто их сравниваем
        } else if (typeof (prop1) !== "object" && typeof (prop2) !== "object") {
            if (prop1 !== prop2)
                return false;
        }
    }

    return true;
}
//--------------------------------------------------------------
export const queryFilterByItem = (item) => {
    if (!item) return "";
    let query = [];
    for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
            const value = item[key];
            let keyName = (key.endsWith('ID') === true) ? key.slice(0, -2) + ".ID" : key;
            if (value) {
                query.push("w-" + keyName + "=" + value);
            }
        }
    }
    return query.join("&");
}
export const filterByItem = (item, element) => {
    for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
            const value = item[key];
            if (element[key] === value) {
                return true;
            }
        }
    }
    return false;
}
//--------------------------------------------------------------
export const errorCatch = (err, type, callback) => {
    if (err) {
        if (type === "fail") {
            message.error(err.message);
            if (err.exception) {
                console.error(err.exception)
            }
        }
        if (type === "error") {
            message.error("" + err);
        }
        if (callback) callback();
    }
};
export const errorAlert = (err, type, callback) => {
    const messageError = (err) => {
        const alertInstance = alert('Ошибка', err, [
            { text: 'OK', onPress: () => alertInstance.close() },
        ]);
        setTimeout(() => {
            alertInstance.close();
        }, 5000);
    };
    if (err) {
        if (type === "fail") {
            messageError(err.message);
            if (err.exception) {
                console.error(err.exception)
            }
        }
        if (type === "error") {
            messageError("" + err);
        }
        if (callback) callback();
    }
};
export const messageError = (err) => {
    const alertInstance = alert('Ошибка', err, [
        { text: 'OK', onPress: () => alertInstance.close() },
    ]);
    setTimeout(() => {
        alertInstance.close();
    }, 5000);
};
//--------------------------------------------------------------
export const arrayUnpack = (values, field, target) => {
    var f = values[field];
    delete values[field];
    for (let i = 0; i < target.length; i++) {
        values[target[i]] = f[i];
    }
    return values;
}
//--------------------------------------------------------------
export const upgradeInArray = (array, item) => {
    if (!item) return item;
    if (_.isArray(item)) {
        return item;
    }
    return [item];
}
export const createInArray = (array, item) => {
    return updateInArray(array, item);
}
export const updateInArray = (array, item) => {
    if (!item || !item.ID) return array;
    if (_.findIndex(array, { ID: item.ID }) >= 0) {
        return array.map(e => IfElse(e.ID === item.ID, item, e));
    } else {
        return [...array, item];
    }
    return;
}
export const deleteInArray = (array, item) => {
    if (!array) return array;
    if (!item || !item.ID) return array;
    return array.filter(e => e.ID !== item.ID);
    // mutate the original array and return removed elements
    // _.remove(array, e=>e.ID === item.ID);
}
export const emptyInArray = (array, item) => {
    return [];
}
export const undefinedInArray = (array, item) => {
    return undefined;
}
//--------------------------------------------------------------
export const makeFormData = (values) => {
    const formData = new FormData();
    for (const key in values) {
        if (Object.hasOwnProperty.call(values, key)) {
            const value = values[key];
            if (_.isArray(value)) {
                value.forEach(item => {
                    formData.append(key, item);
                });
            } else {
                formData.append(key, value);
            }
        }
    }
    return formData;
}
//--------------------------------------------------------------
export const unpackFormFields = (form, values) => {
    if (!form) return values;
    var fields = form.getFieldsValue();
    for (var name in fields) {
        if (name.startsWith("@")) {
            var flds = form.getFieldInstance(name).props.fields;
            values = arrayUnpack(values, name, flds);
        }
    }
    return values;
}
//--------------------------------------------------------------
export const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
};
//--------------------------------------------------------------
export const eventExecution = (event, values, context) => {
    if (!event) return values;
    return event(values, context) || values;
};
export const detectMutation = (mutation) => {
    if (_.isFunction(mutation)) {
        return mutation;
    } else if (_.isString(mutation)) {
        switch (mutation) {
            case "upgrade": return upgradeInArray;
            case "create": return createInArray;
            case "update": return updateInArray;
            case "delete": return deleteInArray;
            case "empty": return emptyInArray;
            case "undefined": return undefinedInArray;
            default:
                return updateInArray;
        }
    }
    return updateInArray;
};
export const Request = (values, item, props) => {
    const {
        auth,
        collection,
        setCollection,

        index,
        lock,
        unlock,
        close,
        onValues,
        onData,
        onClose,
        onError,
        onDispatch,
    } = props;
    if (item.action) {
        let properties = {
            item,
            index,
            collection,
            setCollection,
        };
        if (_.isFunction(item.action)) {
            // Свойство action может быть функцией или объектом
            // action: (values, unlock, close, {item, index})=>{}
            // если функция после того как отработает вернет в качестве результата ещё одну функцию,
            // то она (_dispatch) будет вызванаивнеё передан объект сбольшимчислом параметров
            let v = eventExecution(onValues, values, properties);
            let _dispatch = item.action(v, unlock, close, properties);
            if (_.isFunction(_dispatch)) {
                _dispatch(properties);
            }
        } else if (_.isObject(item.action)) {
            let config = item.action;
            // {
            //    ! method: "POST",
            //    ! path: "/api/request",
            //    ! mutation: "update", - может быть строкой "create", "update" или "delete", а так же функцией createInArray(array, item), updateInArray(array, item), deleteInArray(array, item) из модуля Tool или новой функцией
            //     onValues: (values, context) => {},
            //     onData: (values, context) => {},
            //     onClose: ({unlock, close}, context) => {},
            //     onError: (err, type, {unlock, close}) => {},
            //     onDispatch: (values, context) => {},
            // }
            let _REQUEST_ = (auth, url, object, callback, error) => {
                if (config.method === "POSTFormData") {
                    return POSTFormData(auth, url, object, callback, error);
                } else if (config.method === "POST") {
                    return POST(auth, url, object, callback, error);
                }
                return GET(auth, url, callback, error);
            };
            let errFunc = config.onError || onError;
            let payload = eventExecution(config.onValues || onValues, values, properties);
            if (lock) lock();
            _REQUEST_(
                auth,
                config.path,
                payload,
                (x) => {
                    let onDispatchFunc = config.onDispatch || onDispatch;
                    let mutation = detectMutation(config.mutation);
                    let v = mutation(
                        collection,
                        eventExecution(config.onData || onData, x, properties)
                    );
                    if (onDispatchFunc) {
                        let _dispatch = onDispatchFunc(v, properties);
                        if (_.isFunction(_dispatch)) {
                            _dispatch(v);
                        } else {
                            setCollection(v);
                        }
                    } else {
                        setCollection(v);
                    }
                    eventExecution(config.onClose || onClose, { unlock, close }, properties);
                },
                (err, type) => (errFunc) ? errFunc(err, type, { unlock, close }) : errorCatch(err, type, unlock)
            );
        }
    } else {
        console.error("Не задано свойство action для указанного действия")
    }
}
//-------------------------------------------------------------------
//По событию перехода на предыдущую страницу браузера (history.back())
//закрывает текущую модаль, предотвращая полное обновление страницы
export const pushStateHistoryModal = (setVisible, getStack) => {
    //История браузера
    //https://developer.mozilla.org/ru/docs/Web/API/History_API
    var cbFuncName = 'modal_' + fuuid();
    window.history.replaceState({ ...window.history.state, cb: cbFuncName }, '');
    window.history.pushState(null, null, '');
    window.historyCallbackFunctions = window.historyCallbackFunctions || [];
    window.historyCallbackFunctions[cbFuncName] = function (e) {
        delete window.historyCallbackFunctions[cbFuncName];
        setVisible(false);

        window.history.replaceState({ ...window.history.state, cb: undefined }, '');
        if (getStack) {
            var stack = getStack();
            while (stack.length > 0) {
                var fun = stack.pop();
                if (fun) {
                    fun();
                }
            }
        }
    };
}
//-------------------------------------------------------------------
export function _fire(props, modal) {
    // const stack = [];
    // const getStack = () => {
    //     return stack;
    // };

    var config = {
        ...props,
        visible: true
    };
    function destroy() {
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        // for (var len = arguments.length, args = new Array(len), key = 0; key < len; key++) {
        //     args[key] = arguments[key];
        // }
        // var triggerCancel = args.some(function (param) {
        //     return param && param.triggerCancel;
        // });
        // if (props.onCancel && triggerCancel) {
        //     props.onCancel.apply(props, args);
        // }
    }
    function render(props) {
        setTimeout(function () {
            var c = React.createElement(modal, props, props.content);
            ReactDOM.render(c, div);
        });
    }
    function setVisible(visible) {
        if (!visible) {
            var ctx = this;
            // for (var len = arguments.length, args = new Array(len), key = 0; key < len; key++) {
            //     args[key] = arguments[key];
            // }
            config = {
                ...props,
                visible: false,
                afterClose: function afterClose() {
                    if (typeof props.afterClose === 'function') {
                        props.afterClose();
                    }
                    destroy.apply(ctx, /*args*/ undefined);
                }
            };
            render(config);
        }
    }
    function close() {
        window.history.back();
    }
    function update(upd) {
        if (typeof upd === 'function') {
            config = upd(config);
        } else {
            config = { ...props, ...upd };
        }
        render(config);
    }
    // if(props.stackFunc){
    //     stack.push(props.stackFunc)
    // }

    var div = document.createElement('div');
    document.body.appendChild(div);
    pushStateHistoryModal(setVisible, /*getStack*/ undefined);
    render(config);

    return undefined;
}
//-------------------------------------------------------------------
export function fire(props, component) {
    var div = document.createElement('div');
    // document.body.appendChild(div);
    const stack = [];
    const getStack = () => {
        return stack;
    };
    var currentConfig = {
        ...props,
        close: close,
        onCancel: (c) => {
            if (typeof props.onCancel === 'function') {
                props.onCancel(close);
            } else {
                close();
            }
        },
        onOk: () => {
            if (typeof props.onOk === 'function') {
                props.onOk(close);
            } else {
                close();
            }
        },
        visible: true
    };
    function destroy() {
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        for (var len = arguments.length, args = new Array(len), key = 0; key < len; key++) {
            args[key] = arguments[key];
        }
        var triggerCancel = args.some(function (param) {
            return param && param.triggerCancel;
        });

        if (props.onCancel && triggerCancel) {
            props.onCancel.apply(props, args);
        }
    }
    function render(props) {
        setTimeout(function () {
            var c = React.createElement(component, props, props.content);
            ReactDOM.render(c, div);
        });
    }
    function setVisible(visible) {
        if (!visible) {
            var ctx = this;
            for (var len = arguments.length, args = new Array(len), key = 0; key < len; key++) {
                args[key] = arguments[key];
            }
            currentConfig = {
                ...props,
                visible: false,
                afterClose: function afterClose() {
                    if (typeof props.afterClose === 'function') {
                        props.afterClose();
                    }
                    destroy.apply(ctx, args);
                }
            };
            render(currentConfig);
        }
    }
    function close() {
        // console.log("back");
        window.history.back();
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') {
            currentConfig = configUpdate(currentConfig);
        } else {
            currentConfig = { ...props, ...configUpdate };
        }
        render(currentConfig);
    }
    if (props.stackFunc) {
        stack.push(props.stackFunc)
    }
    pushStateHistoryModal(setVisible, getStack);
    render(currentConfig);
    return {
        destroy: close,
        update: update
    };
}
//-------------------------------------------------------------------
export function JSX(render) {
    return render();
}
export function JSXMap(array, render) {
    if (!array) return <></>;
    var jsx = [];
    for (let i = 0; i < array.length; i++) {
        const e = array[i];
        let ok = render(e, i);
        if (ok) {
            jsx.push(ok);
        }
    }
    return jsx;
}
export function JSXPathMap(object, path, render) {
    let array = _.get(object, path);
    return JSXMap(array, render);
}
export function JSXIndex(array, index, render) {
    if (!array) return <></>;
    if (!_.isArray(index)) {
        if (array.length < index) return <></>;
        return render(array[index], index);
    } else {
        return index.map((i, idx) => JSXIndex(array, i, render));
    }
}
export function JSXFirst(array, render) {
    return JSXIndex(array, 0, render);
}
//-------------------------------------------------------------------
export function GetMetaPropertyByPath(meta, obj, path) {
    let properties = GetMetaProperties(obj);
    let array = path.split(".");
    if (array.length > 1) {
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            let property = properties.find(e => e.name.toLowerCase() == element.toLowerCase())
            let nobj = _.get(property, "relation.reference.object");
            let type = _.get(property, "relation.type");
            if (nobj) {
                let mnobj = meta[nobj] || meta[nobj.toLowerCase()];
                if (mnobj) {
                    return GetMetaPropertyByPath(meta, mnobj, array.slice(1, array.length).join("."))
                }
            }
        }
    } else {
        return properties.find(e => e.name.toLowerCase() == path.toLowerCase());
    }
};
export function GetMetaProperties(meta, exclude) {
    var xmeta = GetMeta(meta)
    if (typeof xmeta === "object" && !Array.isArray(xmeta)) {
        let p = xmeta.properties;
        if (p && exclude) {
            p = p.filter(e => exclude.findIndex(f => f.toLowerCase() === e.name.toLowerCase()) < 0);
        }
        return p;
    } else if (typeof xmeta === "object" && Array.isArray(xmeta)) {
        return xmeta;
    } else {
        console.warn("Не удалось определить метаданные из переданного параметра");
    }
};

export function GetMeta(meta) {
    if (meta && meta !== null && typeof meta === "function") {
        let m = meta();
        if (m && m !== null && typeof m === "function") {
            return GetMeta(m);
        } else if (typeof m === "object") {
            return m;
        }
    }
    return meta;
};
//-------------------------------------------------------------------
//Получение значения объекта. object - сам объект, subObject - строка содержащая описание подъобъекта.
export function getObjectValue(object, subObject) {
    //Если присутствуют под объекты.
    if (object && subObject) {
        //            var subObjects = subObject.split('.');
        //разбиваем строку subObject через "." не трогая при этом точки в угловых скобках [sdf.sdf]
        var subObjects = subObject
            .replace(/\[[\wа-яА-ЯёЁ\d\."']*\]/g, function (item) {
                return item.replace(".", "<<8>>")
            })
            .split(".")
            .map(function (item) {
                return item.replace(/<<8>>/g, ".");
            });
        //Перебираем под объекты
        for (var i = 0; i < subObjects.length; i++) {
            var index = subObjects[i].match(/\[.*\]/);
            var subObj = subObjects[i].replace(/\[.*\]/, "");
            if (subObj) {
                var lastObj = subObj;

                if (object === null) {
                    console.debug("Ошибка получения объекта: " + subObject + "; Не удается найти свойство: " + "\"" + subObj + "\"");
                    return;
                }

                object = object[subObj];
                if (object === undefined) {
                    console.debug("Ошибка получения объекта: " + subObject + "; Не удается найти свойство: " + "\"" + subObj + "\"");
                    return;
                }

                //Проверяем является ли под объект массивом
                if (index) {
                    var rexp = /\[([\wа-яА-ЯёЁ\d\.]+)\]|\[["|']([\wа-яА-ЯёЁ\d\.]+)["|']\]/g;
                    var matchArray;
                    //Поиск всех индексов для n-мерного массива
                    while ((matchArray = rexp.exec(index))) {
                        var matchIndex = matchArray[1] || matchArray[2];
                        if (matchIndex) {
                            object = object[matchIndex];
                            if (object === undefined) {
                                console.debug("Ошибка получения объекта: " + subObject + "; Не существует элемента с индексом: \"" + matchIndex + "\" в объекте: " + lastObj);
                                return;
                            }
                        } else {
                            console.debug("Ошибка получения объекта: " + subObject + "; Не могу получить указанный объект. Ошибка получения индекса элемента.");
                            return;
                        }
                    }
                }
            } else {
                console.debug("Ошибка получения объекта: " + subObject + "; Не могу получить указанный объект.");
                return;
            }
        }
    }
    return object;
}
export function getObjectValueOrDefault(object, subObject, defValue) {
    var result = getObjectValue(object, subObject);
    if (result === undefined || result === null) {
        if (defValue !== undefined) {
            return defValue;
        }
    }
    return result;
}
export function getBooleanPresenter(value) {
    return (value) ? "Да" : "Нет"
}
export function getSimpleDisplay(value) {
    if (!_.isObject(value) && !_.isBoolean(value)) {
        return "" + value;
    } else if (_.isBoolean(value)) {
        return getBooleanPresenter(value)
    }
}
export function getObjectDisplay(data, name, meta) {
    if (!name) return getSimpleDisplay(data)
    if (!meta || data === undefined || data === null) return undefined;
    const display = (display) => {
        if (display.fields) {
            return display
        }
    }
    const metaObject = meta[name] || meta[name.toLowerCase()];
    if (metaObject) {
        return getDisplay(data, display(metaObject.display), metaObject, meta)
    }
    return getSimpleDisplay(data)
}
export function getFieldDisplay(data, propertyMeta, meta) {
    if (!propertyMeta || !_.isObject(propertyMeta)) return getSimpleDisplay(data)
    if (!meta || data === undefined || data === null) return undefined;
    const display = (display) => {
        if (display.fields) {
            return display
        }
    }
    const o = getObjectValue(propertyMeta, "relation.reference.object");
    if (!o && !_.isObject(data)) {
        return data;
    }
    if (o) {
        const metaObject = meta[o] || meta[o.toLowerCase()];
        if (metaObject) {
            return getDisplay(data, display(propertyMeta.relation.display) || display(metaObject.display), metaObject, meta)
        }
    }
    return getSimpleDisplay(data)
}
export function getFieldDisplayForTable(data, propertyMeta, meta) {
    return getFieldDisplay(data, propertyMeta, meta, "displayTable");
}
export function getFieldDisplayForFilter(data, propertyMeta, meta) {
    return getFieldDisplay(data, propertyMeta, meta, "displayFilter");
}
/**
 * Возвращает представление объекта по его данным
 * @param {type} data данные объекта
 * @param {type} display структура представления объекта
 * @param {type} metaObject информация об объекте
 * @param {type} meta мета
 * @return представление объекта
 */
export function getDisplay(data, display, metaObject, meta) {
    var result = "";
    if (data === undefined || data === null) {
        return result;
    }
    if (!_.isObject(data)) {
        return getSimpleDisplay(data)
    }
    //        if (!display || !display.fields) {
    //            display = meta.display;
    //        }
    if (!display || !display.fields) {
        return result;
    }
    var sep = "";
    if (display.sep) {
        sep = display.sep;
    }
    for (var i = 0; i < display.fields.length; i++) {
        //получили поле, получили значение поля
        var field = display.fields[i];

        var name_field = field.value.split(".").map((e) => uncapitalize(e)).join(".");

        var value_field = getObjectValue(data, name_field);

        if (_.isObject(value_field)) {
            const o = metaGetFieldByName(metaObject, meta, name_field);
            value_field = getDisplay(value_field, o.relation.display, metaObject, meta);

            if (!value_field) {
                var subMeta = meta[o.relation.reference.object.toLowerCase()];
                value_field = getDisplay(getObjectValue(data, name_field), subMeta.display, subMeta, meta);
            }
        }

        //Если задан объект meta, пытаемся отформатировать поле в соответствии с типом
        var metaField = metaGetFieldByName(metaObject, meta, name_field);

        if (metaField && metaField.type) {
            value_field = getFormatFieldValueTableView(value_field, metaField.type, metaField);
        }

        if (value_field) {
            result += ((field.prefix) || "") + value_field + ((field.suffix) || "");

            if (i < display.fields.length - 1) {
                result += sep;
            }
        }
    }

    return result;
}

/**
 * Глубоко клонирует объект objectName
 * @param objectName клонируемый объект
 * @return клонированный объек
 */
export function metaGetCloneObject(objectName, meta) {
    return _.cloneDeep(meta[objectName]);
};

/**
 * Возвращает поле по имени если такое содержится в объекте metaObject
 * @param metaObject объект метаданных или имя объекта метаданных
 * @param string|array fieldName имя поля в объекте метаданных может быть составное через точку, 
 * или массив составляющий поле
 * @return {Object}
 */
export function metaGetFieldByName(metaObject, meta, fieldName) {
    //Если передали имя объекта метаданых, то извлекаем сам объект
    if (typeof (metaObject) === "string") {
        var metaObject = metaGetCloneObject(metaObject, meta);
    } else if (typeof (metaObject) !== "object") {
        return;
    }
    if (!getObjectValue(metaObject, "properties.length") || !fieldName) {
        return;
    }

    if (typeof (fieldName) === "string") {
        fieldName = fieldName.split(".");
    }

    if (!fieldName.length || fieldName.length < 1) {
        return;
    }

    for (var tag in metaObject.properties) {
        if (metaObject.properties[tag].name && fieldName[0] && metaObject.properties[tag].name.toLowerCase() === fieldName[0].toLowerCase()) {
            //Если сейчас не последняя часть fieldName
            if (fieldName.length > 1) {
                //Если текущая часть является объектом
                var subObjectName = getObjectValue(metaObject, "properties[" + tag + "].relation.reference.object");
                if (subObjectName) {
                    return metaGetFieldByName(meta[subObjectName], fieldName.slice(1));
                } else {
                    console.error("metaGetFieldByName. Не удалось найти " + fieldName + " в объекте " + metaObject.name, metaObject);
                    return;
                }
            } else {
                return metaObject.properties[tag];
            }
        }
    }
}

/**
 * Возвращает поля DisplayFields
 * @param {type} display структура представления объекта
 * @param {type} metaObject информация об объекте
 * @param {type} parent родительский объект конкатенируется к текущему полю через точку
 * @param {type} result итоговый массив полей
 * @return массив полей
 */
export function getSortingDisplayFields(display, metaObject, meta, parent, result) {
    result = result || [];
    parent = parent || "";
    if (!display || !display.length || !metaObject) {
        return result;
    }

    for (var i = 0; i < display.length; i++) {
        var field = display[i];

        if (!field.sorting) {
            continue;
        }

        var name_field = field.value.split(".").map((e) => uncapitalize(e)).join(".");
        var metaField = metaGetFieldByName(metaObject, name_field);

        if (parent) {
            name_field = parent + "." + name_field;
        }
        if (getObjectValue(metaField, "relation.reference.object") && meta[metaField.relation.reference.object]) {
            var fieldMeta = meta[metaField.relation.reference.object];
            getSortingDisplayFields(metaField.relation.display || fieldMeta.display, fieldMeta, meta, name_field, result);
        } else {
            result.push(name_field);
        }
    }
    return result;
}
export function typeIsNumber(type) {
    return (type === "int" ||
        type === "integer" ||
        type === "long" ||
        type === "double" ||
        type === "bigdecimal");
}
/**
 * Извлекает значение поля для отображения в таблице
 * @return 
 */
export function getFormatFieldValueTableView(data, type, meta) {
    if (type === "boolean" || type === "bool") {
        var trueValue = getObjectValueOrDefault(meta, "booleanPresenter.trueValue", "Да");
        var falseValue = getObjectValueOrDefault(meta, "booleanPresenter.falseValue", "Нет");
        return data ? trueValue : falseValue;
        //return data ? "<span style='font-weight: 600;'>"+trueValue+"</span>" : "<span>"+falseValue+"</span>";
    }

    if (!data) {
        return '';
    }

    if (type === "timestamp" || type === "datetime" || type == "localdatetime") {
        var mDate = moment(data);
        if (mDate && mDate.isValid()) {
            return mDate.format("DD.MM.YYYY HH:mm:ss");
        }
    } else if (type === "date" || type == "localdate") {
        var mDate = moment(data);
        if (mDate && mDate.isValid()) {
            return mDate.format("DD.MM.YYYY");
        }
    } else if (type === "time" || type === "localtime") {
        var mDate = '';
        if (data.length <= 8) {
            mDate = moment(data, "HH:mm:ss");
        } else if (data.length > 8) {
            mDate = moment(data);
        }

        if (mDate && mDate.isValid()) {
            return mDate.format("HH:mm:ss");
        }
    } else if (type === "int" || type === "uint" ||
        type === "integer" ||
        type === "long") {
        return priceFormat(data);
    } else if (type === "double" ||
        type === "bigdecimal" || type === "float") {
        return priceFormat(data, 2);
    } else {
        return data;
    }

    return '';
}

/**
 * Форматирует число в формат цены
 * @param double price цена до форматирования
 * @param int precision точность
 * @return String
 */
export function priceFormat(price, precision) {
    if (!price) {
        price = 0;
    }

    if (typeof (price) === "string") {
        price = Number.parseFloat(price.trim().replace(" ", "").replace(",", "."))
    }

    if (!precision) {
        precision = 0;
    }

    var format = "0,0";
    for (var i = 0; i < precision; i++) {
        if (i === 0) {
            format += ".";
        }
        format += "0";
    }
    return numeral(price).format(format);
}

// MetaColumns(metaObj.properties, meta, ArrayOfActionObjects)
export function MetaColumns(properties, meta, onColumnClick) {
    return ({ request /*(values, itemAction)*/, auth, collection, setCollection }) => {
        const click = (record, item) => {
            if (onColumnClick && item && onColumnClick[item.name]) {
                request(record, { action: onColumnClick[item.name] });
            }
        };
        return properties.map((item, idx) => {
            if (item.type === "object" || item.type === "document") {
                let fieldMeta = meta[getObjectValue(item, "relation.reference.object")];
                const display = (display) => {
                    if (display.fields) {
                        return display
                    }
                }
                return ({
                    title: item.label,
                    render: (text, record, index) => {
                        return (<div style={(onColumnClick && onColumnClick[item.name]) ? { cursor: "pointer", color: "#1890ff" } : {}} onClick={() => click(record, item)}>{getDisplay(record[uncapitalize(item.name)], display(item.relation.display) || display(fieldMeta.display), fieldMeta, meta)}</div>)
                    }
                })
            }
            return ({
                title: item.label,
                render: (text, record, index) => {
                    return (<div style={(onColumnClick && onColumnClick[item.name]) ? { cursor: "pointer", color: "#1890ff" } : {}} onClick={() => click(record, item)}>{getFormatFieldValueTableView(record[uncapitalize(item.name)], item.type, item)}</div>)
                }
            })
        })
    }
};
//---------------------------------------------------------------------------------------
// agro-platform tools
//---------------------------------------------------------------------------------------
export const HasAnswer = (context, questionID, answerContext) => {
    if (!context || !context.contextAnswerContext) return false;
    for (let i = 0; i < context.contextAnswerContext.length; i++) {
        const answer = context.contextAnswerContext[i];
        if (answerContext) {
            if (answer.questionID === questionID && answer.answerContext === answerContext) {
                return true;
            }
        } else {
            if (answer.questionID === questionID) {
                return true;
            }
        }
    }
    return false;
};
export const GetAnswer = (context, questionID, answerContext) => {
    if (!context || !context.contextAnswerContext) return;
    let collect = [];
    for (let i = 0; i < context.contextAnswerContext.length; i++) {
        const answer = context.contextAnswerContext[i];
        if (answerContext) {
            if (answer.questionID === questionID && answer.answerContext === answerContext) {
                collect.push(answer);
            }
        } else {
            if (answer.questionID === questionID) {
                collect.push(answer);
            }
        }
    }
    return collect;
};
export const getAnswerValue = (answer) => {
    if (!answer) return;
    switch (answer.answerTypeID) {
        case 2: //string
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerString,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 3: //bool
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerBool,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 4: //int
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerInt,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 5: //float
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerFloat,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 6: //date
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerDate,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 10: //json
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerJson,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 7: //select
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerID,
                answerObject: answer.answerObject,
                answerDisplay: answer.answerDisplay,
                answerTypeID: answer.answerTypeID,
                questionID: answer.questionID
            }
        case 8: //multiselect
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerID,
                answerObject: answer.answerObject,
                answerDisplay: answer.answerDisplay,
                answerTypeID: answer.answerTypeID,
                questionID: answer.questionID
            }
        case 9: //object
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerID,
                answerContext: answer.answerContext,
                answerObject: answer.answerObject,
                answerDisplay: answer.answerDisplay,
                answerTypeID: answer.answerTypeID,
                questionID: answer.questionID
            }
        default: // void
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerString,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
    }
};
export const getAnswersFromContext = (context, question) => {
    if (!context || !context.contextAnswerContext) {
        return [];
    }
    let answers = [];
    for (let i = 0; i < context.contextAnswerContext.length; i++) {
        const answer = context.contextAnswerContext[i];
        if (answer.questionID === question.ID) {
            answers.push(getAnswerValue(answer));
        }
    }
    return answers;
};
export const getObjectAnswerFromContext = (context, question, subquestion) => {
    const aswersFromContext = getAnswersFromContext(context, question);
    if (aswersFromContext) {
        let v = aswersFromContext.filter(e => e.answerContext === subquestion.ID);
        if (v) {
            return v;
        }
    }
    return;
};
export const makeAnswer = (context, question, value, display, subquestion, objectName) => {
    let o = {
        answerTypeID: question.answerTypeID,
        questionID: question.ID,
        contextID: context.ID
        // ID
    };
    switch (question.answerTypeID) {
        case 2: //string
            o["answerString"] = value;
            break;
        case 3: //bool
            o["answerBool"] = value;
            break;
        case 4: //int
            o["answerInt"] = value;
            break;
        case 5: //float
            o["answerFloat"] = value;
            break;
        case 6: //date
            o["answerDate"] = value;
            break;
        case 10: //json
            o["answerJson"] = value;
            break;
        case 7: //select
            o["answerID"] = value;
            o["answerObject"] = question.objectName;
            o["answerDisplay"] = display;
            break;
        case 8: //multiselect
            o["answerID"] = value;
            o["answerObject"] = question.objectName;
            o["answerDisplay"] = display;
            break;
        case 9: //object
            // o["answerContextTypeID"] = subquestion.answerTypeID;
            switch (subquestion.answerTypeID) {
                case 2: //string
                    o["answerString"] = value;
                    break;
                case 3: //bool
                    o["answerBool"] = value;
                    break;
                case 4: //int
                    o["answerInt"] = value;
                    break;
                case 5: //float
                    o["answerFloat"] = value;
                    break;
                case 6: //date
                    o["answerDate"] = value;
                    break;
                case 10: //json
                    o["answerJson"] = value;
                    break;
                case 7: //select
                    o["answerID"] = value;
                    break;
                case 8: //multiselect
                    o["answerID"] = value;
                    break;
                case 9: //object
                    o["answerID"] = value;
                    o["answerObject"] = objectName; //question.objectName;
                    break;
                default: // void
                    o["answerID"] = value;
                    break;
            }
            o["answerDisplay"] = display;
            o["answerContext"] = subquestion.ID; // идентификатор вопроса в группе
            o["answerName"] = subquestion.name || subquestion.title; // Наименование вопроса в группе
            break;
        default: // void
            o["answerString"] = value;
            break;
    }
    return o;
};
export const detailAnswer = (auth, contextAnswer, callback) => {
    if (contextAnswer && contextAnswer.answerObject) {
        READWITH(auth, contextAnswer.answerObject,
            [
                QueryDetail("model"),
                QueryParam("w-ID", contextAnswer.value)
            ],
            (res) => callback(_.get(res, "data[0]")),
            errorCatch
        );
    }
};
export const answersClearAll = (auth, context, onChange, { lock, unlock }) => {
    if (lock) lock();
    GET(auth, `/api/context/answer/clear/context/${context.ID}`, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err, type) => errorCatch(err, type, unlock));
};
export const answersClear = (auth, context, question, onChange, { lock, unlock }) => {
    if (lock) lock();
    GET(auth, `/api/context/answer/clear/context/${context.ID}/question/${question.ID}`, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err, type) => errorCatch(err, type, unlock));
};
export const answersDelete = (auth, context, question, answer, onChange, { lock, unlock }) => {
    if (lock) lock();
    POST(auth, "/api/context/answer/delete", answer, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err, type) => errorCatch(err, type, unlock));
};
export const answersAppend = (auth, context, question, answer, onChange, { lock, unlock }) => {
    if (lock) lock();
    POST(auth, "/api/context/answer/add", answer, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err, type) => errorCatch(err, type, unlock));
};
export const funcClient = (auth, context, serviceID, fsmFunctionID, question, answer, onChange, { lock, unlock }) => {
    if (lock) lock();
    POST(auth, `/api/func/client/${serviceID}/${fsmFunctionID}`, answer, ({ data }) => {
        if (onChange) {
            onChange(data);
        }
        if (unlock) unlock();
    }, (err, type) => errorCatch(err, type, unlock));
};
//---------------------------------------------------------------------------------------
//---------------------------------------------------------------------------------------
